var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00008 13.25C6.28146 13.25 6.27537 12.7272 5.65627 12.2811C4.5793 11.5052 2.92387 10.5922 1.60579 10.4134C1.36952 10.3873 1.15131 10.2746 0.993274 10.097C0.835236 9.91941 0.748576 9.6896 0.750018 9.45189V1.71143C0.750009 1.57254 0.780087 1.4353 0.838183 1.30915C0.896279 1.183 0.981015 1.07093 1.08656 0.980655C1.19024 0.892021 1.3116 0.826461 1.44257 0.788331C1.57354 0.750201 1.71112 0.740373 1.84618 0.7595C3.8311 1.08893 5.64691 2.07814 7.00008 3.56722V13.25Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00005 13.25C7.71866 13.25 7.72475 12.7272 8.34385 12.2811C9.42082 11.5052 11.0763 10.5922 12.3943 10.4134C12.6306 10.3873 12.8488 10.2746 13.0068 10.097C13.1649 9.91941 13.2515 9.6896 13.2501 9.45189V1.71143C13.2501 1.57254 13.22 1.4353 13.1619 1.30915C13.1038 1.183 13.0191 1.07093 12.9136 0.980655C12.8099 0.892021 12.6885 0.826461 12.5576 0.788331C12.4266 0.750201 12.289 0.740373 12.1539 0.7595C10.169 1.08893 8.35322 2.07814 7.00005 3.56722V13.25Z",
    fill: "white",
    stroke: "#0C0C0C",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcon);
export default __webpack_public_path__ + "static/media/school-icon.3fba6b1003a300d0bce2e89a68298a42.svg";
export { ForwardRef as ReactComponent };